import { IElement } from "processEditor/model/IProcessData";
import * as React from "react";
import DisposeEditor from "./DisposeEditor";
import { default as InputEditor } from "./InputEditor";
import { default as LogResultEditor } from "./LogResultEditor";
import { default as ParameterInput } from "./ParameterInput";
import { SwitchCollapse } from "./SwitchCollapse";

const hasVariableType = (variableType: any) => {
    if (variableType == null) {
        return false;
    }

    return variableType != "";
};

export const ForeachEditor: React.FC<ForeachProps> = (props) => {
    const isAdvancedOptionOpenByDefault = hasVariableType(props.existingParameters["variableType"]) || props.shouldDisposeIterator;

    const advancedSettingEditors = <>
        <InputEditor
            name="variableType"
            key="variableTypeEditor"
            label={FRENDS.Localizations.Type}
            tooltip={FRENDS.Localizations.IteratorTypeToolTip}
            elementId={props.id}
            value={props.existingParameters["variableType"] || ""}
        />
        <DisposeEditor elementId={props.id} />
    </>;

    return (<div>
        <SwitchCollapse
            isOpenByDefault={isAdvancedOptionOpenByDefault}
            childrenCollapsed={null}
            childrenOpen={advancedSettingEditors}
        />
        <hr />
        <InputEditor name="variable" label={FRENDS.Localizations.Variable} elementId={props.id} value={props.existingParameters["variable"]} />
        <ParameterInput name="expression" label={FRENDS.Localizations.Expression} elementId={props.id} value={props.existingParameters["expression"]} />
        <LogResultEditor elementId={props.id} />
    </div>
    );
};

interface ForeachProps {
    id: string;
    shouldDisposeIterator?: boolean;
    existingParameters: any;
}
